import React, { ReactElement } from 'react';
import { css } from '@emotion/react';
import Image from 'next/image';

import { IResponse, Icases } from '@/types/crime';

interface Iprops {
  data: IResponse;
}
export const CaseLists = ({ data }: Iprops): ReactElement => {
  const title = (cases: Icases[]): JSX.Element => {
    return (
      <>
        {cases.map((ele) => {
          return (
            <li
              key={ele.auto_hash}
              css={css`
                margin: 5px 0;
                padding-left: 2rem;
                text-indent: -1rem;
              `}
            >
              <a
                css={css`
                  color: #6f6f6f;
                  text-decoration: none;
                  &:hover {
                    font-weight: 500;
                  }
                `}
                href={`https://legalengine.co.kr/cases/${ele.auto_hash}`}
                target='_blank'
                rel='noreferrer'
              >
                <span
                  css={css`
                    margin-right: 0.5rem;
                  `}
                >
                  {ele.title}
                </span>
                <Image src='/crime/new_tab.png' width={15} height={15} />
              </a>
            </li>
          );
        })}
      </>
    );
  };

  const mobileCss = `width: 100%; font-size:16px;`;

  const render = (data: IResponse): JSX.Element => {
    const { output } = data;
    if (output.length === 0) {
      return (
        <div
          css={css`
            display: flex;
            flex-flow: column nowrap;
            justify-content: center;
            align-items: center;
            width: 80%;
            min-height: 200px;
            border: 1px solid #c4c4c4;
            border-radius: 5px;
            color: #6f6f6f;
            font-size: 18px;
            padding: 1rem 2rem;
            @media (max-width: 992px) {
              ${mobileCss}
            }
          `}
        >{`현재 검색한 무죄 판례가 없습니다.`}</div>
      );
    }
    return (
      <div
        css={css`
          display: flex;
          flex-flow: column nowrap;
          justify-content: flex-start;
          align-items: flex-start;
          width: 80%;
          min-height: 200px;
          border: 1px solid #c4c4c4;
          border-radius: 5px;
          color: #6f6f6f;
          font-size: 18px;
          padding: 1rem 2rem;
          @media (max-width: 992px) {
            ${mobileCss}
          }
        `}
      >
        {output.map((ele) => {
          return (
            <React.Fragment key={ele.value}>
              <div
                css={css`
                  border: 2px solid #d93729;
                  box-sizing: border-box;
                  border-radius: 17px;
                  padding: 3px 15px;
                  color: #d93729;
                  font-size: 18px;
                  font-weight: 700;
                  margin: 1rem 0;
                  @media (max-width: 992px) {
                    ${mobileCss}
                    width: fit-content;
                  }
                `}
              >
                {ele.value}
              </div>
              {title(ele.cases)}
            </React.Fragment>
          );
        })}
      </div>
    );
  };
  return (
    <>
      <div
        css={css`
          font-size: 22px;
          font-weight: 700;
          color: #000000;
          width: 80%;
          display: flex;
          flex-flow: row nowrap;
          justify-content: flex-start;
          align-items: center;
          gap: 1rem;
          @media (max-width: 992px) {
            ${mobileCss}
          }
        `}
      >
        <Image
          src='/crime/crime_3.png'
          layout='fixed'
          alt={'Legal Engine'}
          width={25}
          height={25}
        />
        {`무죄 판례`}
      </div>
      {render(data)}
    </>
  );
};
